export default "__VITE_ASSET__C60cxsny__"